// extracted by mini-css-extract-plugin
export default {"article__socials":"ArticleSocials_article__socials__uImig","article__list":"ArticleSocials_article__list__D+EYS","article__link":"ArticleSocials_article__link__XZPz9"};